import Benefit from '@/models/Benefit'

const state = { 
    benefits: [],
}

const getters = {
    benefits: state => state.benefits,
}

const mutations = {
    SET_BENEFITS: (state, data) => (state.benefits = data),
}

const actions = {
    async getBenefitsData({ commit }, levelsIds) {
        const benefits = []
      
        await Promise.all(
            levelsIds.map(async level_id => {
                const benefit = await Benefit.list(level_id)

                if(!benefit) return
                
                benefit.forEach(benefit => benefits.push(benefit))
            })
        )
        
        if(!benefits.length) return
        
        commit('SET_BENEFITS', benefits)

        return benefits
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}